// Get a RTDB instance
import firebase from "firebase/app";
import "firebase/database";

export const db = firebase
  .initializeApp({ databaseURL: "https://daily-todo-2db76.firebaseio.com/" })
  .database();
